export const ConfigurationSetWarningCodes = Object.freeze({
    IsFailingCreationHyperfindExecution: 'IsFailingCreationHyperfindExecution',
    IsFailingManagementHyperfindExecution: 'IsFailingManagementHyperfindExecution',
    IsFailingViewHyperfindExecution: 'IsFailingViewHyperfindExecution',
    AutoArchiveDelayWithRebidAllowed: 'AutoArchiveDelayWithRebidAllowed'
});
